import { ReactNode, FC, useState } from 'react';
import { NotificationsVisibleContext } from '@common/context';
import { Notification } from '@common/components';

interface Props {
  children: ReactNode;
}

const AppProvider: FC<Props> = ({ children }: Props): JSX.Element => {
  const [isNotificationOpen, setIsNotificationOpen] = useState<boolean>(false);
  return (
    <NotificationsVisibleContext.Provider value={{ isOpen: isNotificationOpen, setIsOpen: setIsNotificationOpen }}>
      {children}
      <Notification />
    </NotificationsVisibleContext.Provider>
  );
};

export default AppProvider;
